import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Editor, Toolbar } from 'ngx-editor';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss']
})
export class TextEditorComponent implements OnDestroy {
  @Input() control!: FormControl;
  @Input() submitted: boolean = false;
  @Input() placeholder: string = "";
  @Input() errorMessage: string = "";
  @Input() maxLength: number = 5000;

  editor: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  constructor() {
    this.editor = new Editor();
  }
  @HostListener('paste', ['$event'])
  private pasteFromClipboard(event: KeyboardEvent): void {
    event.preventDefault();

    if (this.insertClipboardImage(event)) {
      return;
    }
  }

  private insertClipboardImage(event: any): File | null {
    const pastedImage = this.getPastedImage(event);

    if (!pastedImage)
      return null;

    return pastedImage;
  }

  private getPastedImage(event: any): File | null {
    if (event.clipboardData) {
      if (event.clipboardData.files && event.clipboardData.files.length && this.isImageFile(event.clipboardData.files[0])) {
        return event.clipboardData.files[0];
      }
    }

    return null;
  }

  private isImageFile(file: File): boolean {
    return file.type.search(/^image\//i) === 0;
  }

  getTextWithoutHtml(text: string): string {
    if (!text) {
      return '';
    }
    return text.replace(/<\/?[^>]+(>|$)/g, ''); // Strips HTML tags
  }

  // make sure to destory the editor
  ngOnDestroy(): void {
    this.editor.destroy();
  }
}
